// Create a copy of the StreamrAudioFrame to make it safe to transfer
// the EncodedAudioFrame to the workers
export function streamrAudioFrameToEncodedAudioFrame(streamrAudioFrame) {
    return {
        frameNumber: streamrAudioFrame.frameNumber,
        timestamp: streamrAudioFrame.timestamp,
        duration: streamrAudioFrame.duration,
        trackId: streamrAudioFrame.trackId,
        data: new Uint8Array(streamrAudioFrame.data),
        done: streamrAudioFrame.done,
        isKeyFrame: streamrAudioFrame.isKeyFrame,
    };
}
export function streamrAudioFrameToInboundEncodedAudioFrame(streamrAudioFrame, userSessionId) {
    return {
        ...streamrAudioFrameToEncodedAudioFrame(streamrAudioFrame),
        userSessionId,
    };
}
export function encodedAudioFrameToAudioFrame(encodedAudioFrame) {
    return {
        frameNumber: encodedAudioFrame.frameNumber,
        timestamp: encodedAudioFrame.timestamp,
        duration: encodedAudioFrame.duration,
        trackId: encodedAudioFrame.trackId,
        data: new Uint8Array(encodedAudioFrame.data),
        done: encodedAudioFrame.done,
        isKeyFrame: encodedAudioFrame.isKeyFrame,
    };
}
export function createDoneEncodedAudioFrame(trackId, frameNumber) {
    return {
        frameNumber: frameNumber,
        timestamp: 0n,
        duration: 0n,
        trackId: trackId,
        data: new Uint8Array(),
        done: true,
        isKeyFrame: true,
    };
}
